import { Edit } from 'react-admin';
import { RoleForm } from './Role.Form';

export const RoleEdit = () => {
    return (
        <Edit>
            <RoleForm />
        </Edit>
    );
};
